import React from 'react';
import {DEFAULT_CONTACT_INFO_FIELDS, UPDATE_PERM} from '../../../../util/util-constants'
import {checkPerm, getLookup, getProp} from '../../../util/util-helpers'
import CardSubTitle from "../../../../common/components/card/card-sub-title";
import Resources from "../../../../data/services/resources";
import FieldsForm from "../../fields/fields-form";

const ALL_CONTACT_FIELD_NAMES = Object.keys(DEFAULT_CONTACT_INFO_FIELDS())
const CONTACT_INFO_FIELD_NAMES = ALL_CONTACT_FIELD_NAMES.slice(0, ALL_CONTACT_FIELD_NAMES.length - 4)
const SYSTEM_ROLE_FIELD_NAMES = ALL_CONTACT_FIELD_NAMES.slice(ALL_CONTACT_FIELD_NAMES.length - 4)

export default function ContactInfoFields({
                                              translate,
                                              fields,
                                              handleInputChange,
                                              selects: selectsProp,
                                              htmlBefore,
                                              hideSystemUser,
                                              selectedItem,
                                              ValidationType,
                                              isReadOnlyMode
                                          }) {
    const selects = selectsProp ?? {
        PersonalTitleID: getLookup("PersonalTitle"),
        Groups: {
            api: "api/" + Resources.ContactGroups,
            query: {},
            searchMap: (item) => ({
                label: item.ContactGroupName,
                value: item.ContactGroupID
            })
        },
        ValidationType: ValidationType ?? {
            1: "Email",
            2: "SMS",
        },
        Roles: getLookup("PermRoles")
    }

    const hideSystemRoleFields = hideSystemUser || (getProp(fields, "IsSystemUser.type", '') === 'hidden')

    return (
        <div>
            <CardSubTitle
                text={translate('modal_heading.contact_info')}
                addClass={'mb-4'}
            />

            {htmlBefore}

            <div className="grid gap-4 grid-cols-12 pb-5">
                <FieldsForm
                    fieldsState={fields}
                    isFormDisabled={isReadOnlyMode}
                    includeFields={CONTACT_INFO_FIELD_NAMES}
                    onChange={handleInputChange}
                    translate={translate}

                    selects={selects}
                />

                {!!selectedItem && !!fields['Groups'] && (
                    <FieldsForm
                        fieldsState={fields}
                        isFormDisabled={isReadOnlyMode}
                        includeFields={['Groups']}
                        onChange={handleInputChange}
                        translate={translate}
                        selects={selects}
                    />
                )}
            </div>

            {!hideSystemRoleFields && !!checkPerm(Resources.UserPermissions, UPDATE_PERM) && (
                <>
                    <CardSubTitle
                        text={translate('modal_heading.SystemRole')}
                    />
                    <div className="grid gap-4 grid-cols-12 pb-5">
                        <FieldsForm
                            fieldsState={fields}
                            isFormDisabled={isReadOnlyMode}
                            includeFields={SYSTEM_ROLE_FIELD_NAMES}
                            onChange={handleInputChange}
                            translate={translate}
                            selects={selects}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
